import { render, staticRenderFns } from "./AppSettings.vue?vue&type=template&id=1a7f9486&scoped=true&"
import script from "./AppSettings.vue?vue&type=script&lang=js&"
export * from "./AppSettings.vue?vue&type=script&lang=js&"
import style0 from "./AppSettings.vue?vue&type=style&index=0&id=1a7f9486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f9486",
  null
  
)

export default component.exports